// extracted by mini-css-extract-plugin
export default {"logosWrapper":"LogosWrapper_logosWrapper__jXV8-","logo":"LogosWrapper_logo__DP-NO"};